<template>
  <div class="box-bolao-info no-jump">
    <div>
      <div class="box_wheel_bolao">
        <div class="wheel_bolao_detail">
          <div class="readonly-game">
            <div class="grid-tens-bolao-wheel">
              <animated-place-holder
                :height="'320px'"
                :maxwidth="'485px'"
                :borderradius="'15px'"
              ></animated-place-holder>
            </div>
          </div>
        </div>
      </div>
      <div class="box_all_cards_bolao mt-2">
        <animated-place-holder
          :height="'40px'"
          :maxwidth="'560px'"
          :borderradius="'15px'"
        ></animated-place-holder>
        <animated-place-holder
          class="ml-2"
          :height="'40px'"
          :maxwidth="'560px'"
          :borderradius="'15px'"
        ></animated-place-holder>
      </div>
    </div>

    <div class="box-bolao-info__info">
      <div class="box-bolao-info__info__top d-flex justify-content-between">
        <div class="box-bolao-info__info__title">

            <animated-place-holder
              class="ml-2"
              :height="'40px'"
              :width="'160px'"
              :borderradius="'15px'"
            ></animated-place-holder>

          <div class="box-bolao-info__info__draw-number d-none d-lg-block">
            <animated-place-holder
              class="ml-2"
              :height="'40px'"
              :width="'160px'"
              :borderradius="'15px'"
            ></animated-place-holder>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <time class="bolao-page__header__draw-date">
            <animated-place-holder
              class="ml-2"
              :height="'40px'"
              :width="'100px'"
              :borderradius="'15px'"
            ></animated-place-holder
          ></time>
        </div>
      </div>

      <div class="box-bolao-info__info__body">
        <div
          class="box-bolao-info__info__draw-summary d-flex justify-content-between align-items-center mb-3"
        >
          <div class="box-bolao-info__info__chances col-lg-6">
            <div
              class="box-bolao-info__info__chances__icon-lottery w-100"
            >
              <animated-place-holder
                class="ml-2"
                :height="'100px'"
                :width="'100%'"
                :maxwidth="'340px'"
                :borderradius="'15px'"
              ></animated-place-holder>
            </div>

          </div>

          <div class="box-bolao-info__info__bolao-price lot-color">
            <animated-place-holder
              class="ml-2"
              :height="'100px'"
              :width="'100px'"
              :borderradius="'15px'"
            ></animated-place-holder>
          </div>
        </div>

        <div
          class="box-bolao-info__info__chances__text__line d-lg-none"
        >
        <animated-place-holder
              class="ml-2"
              :height="'40px'"
              :width="'100px'"
              :borderradius="'15px'"
            ></animated-place-holder>
        </div>

        <div
          class="box-bolao-info__info__config-line d-flex justify-content-between pr-2"
        >

            <animated-place-holder
              class="ml-2"
              :height="'25px'"
              :maxwidth="'400px'"
              :borderradius="'15px'"
            ></animated-place-holder>

          <div class="box-bolao-info__info__quotes">
            <div class="box-bolao-info__info__quotes__available">

            </div>

          </div>
        </div>
      </div>

      <div class="box-bolao-info__info__footer">
        <animated-place-holder
              class="ml-2"
              :height="'40px'"
              :maxwidth="'600px'"
              :borderradius="'15px'"
              :margin="'auto'"
            ></animated-place-holder>
      </div>
    </div>
  </div>
</template>
<style src="./BoxBolaoInfo.scss" scoped></style>
<script>
import AnimatedPlaceHolderVue from '../../6-components/Skeleton/AnimatedPlaceHolder.vue';

export default {
  components: {
    'animated-place-holder': AnimatedPlaceHolderVue
  }
};
</script>
